import React from 'react';
import { createGlobalStyle } from 'styled-components';
import GlobalStyle from 'carbon-react/lib/style/global-style';

export const ExtendedGlobalStyle = createGlobalStyle`
  h1, .h1,
  h2, .h2,
  h3, .h3,
  h4, .h4,
  h5, .h5,
  h6, .h6 {
    margin-bottom: 0;
    font-size: inherit;
    font-weight: inherit
  }
`;

export const AppGlobalStyles = () => {
  return (
    <>
      <GlobalStyle />
      <ExtendedGlobalStyle />
    </>
  );
};
